import * as R from 'ramda';
import parseActivity from './parseActivity';

export default function parseActivities(items) {
  return R.map(parseActivity, items);
}
